import React from 'react';
import filterIcon from '../../../../assets/images/filter.svg';
import searchIcon from '../../../../assets/images/search.svg';
import viewIcon from '../../../../assets/images/view.svg';
import bellIcon from '../../../../assets/images/bell.png';

const TimetableFilters = ({
    isMobile,
    openSearch,
    isSearchOpen,
    isViewFilterOpen,
    openViewOptions,
    toggleFiltersOpen,
    filtersOpen,
    hasFilter,
    toggleActivityOpen,
    activityOpen,
    showDot
}) => (
    <div className={`${isMobile ? 'rp-hidden-760-plus' : 'rp-hidden-760-min'}`}>
        <ul className={`ckp-timetable-actions-group is-without-margin is-transparent`}>
            <li
                onClick={openSearch}
                className={`ckp-timetable-actions-option is-selected ${isSearchOpen ? 'is-pressed' : ''}`}
            >
                <img src={searchIcon} alt="Search" />
            </li>
        </ul>
        <ul className={`ckp-timetable-actions-group rp-hidden-1200-plus is-without-margin is-transparent`}>
            <li
                onClick={openViewOptions}
                className={`ckp-timetable-actions-option is-selected ${isViewFilterOpen ? 'is-pressed' : ''}`}
            >
                <img src={viewIcon} alt="View Options" />
            </li>
        </ul>
        <ul className={`ckp-timetable-actions-group is-without-margin is-transparent`}>
            <li
                onClick={toggleFiltersOpen}
                className={`ckp-timetable-actions-option ${hasFilter ? 'is-highlighted' : ''} is-selected ${
                    filtersOpen ? 'is-pressed' : ''
                }`}
            >
                <img src={filterIcon} alt="Filters" />
            </li>
        </ul>
        <ul className={`ckp-timetable-actions-group is-without-margin is-transparent`}>
            <li
                onClick={toggleActivityOpen}
                className={`ckp-timetable-actions-option ${
                    showDot ? 'ckp-timetable-actions-option--dotted' : ''
                } is-selected ${activityOpen ? 'is-pressed' : ''}`}
            >
                <img className="ckp-timetable-actions-png" src={bellIcon} alt="Activity" />
            </li>
        </ul>
    </div>
);

export default TimetableFilters;
